let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d80uG")).then(() => parcelRequire('dQ2b1'));